import VueI18n from "@/plugins/vue-i18n";
import permissionList from "./jsons/permissionList"
function localize(test) {
  return VueI18n.t(`CONSTANTS.${test}`);
}
let constant = {
  serverAddress: process.env.VUE_APP_API_URL,
  environment: process.env.VUE_APP_ENVIRONMENT,
  KEY_CODES: {
    BACKSPACE: 8,
    CTRL: 17,
    DELETE: 46,
    ENTER: 13,
    SHIFT: 16,
    SPACE: 32,
    TAB: 9,
    LEFT_ARROW: 37,
    UP_ARROW: 38,
    RIGHT_ARROW: 39,
    DOWN_ARROW: 40,
    KEY_A: 65,
    KEY_V: 86,
    KEY_C: 67,
    ESC: 27,
    KEY_Z: 90,
    KEY_Y: 89
  },
  CUSTOM_HTTP_CODES: {
    AlreadyExists: 600,
    AlreadyExistsNotificationReceiver: 601,
    EmptyFieldError: 602,
    MaximumValueExceededError: 603,
    NoQueryForRequest: 604,
    LdapConnectedButUserCouldntFetch: 605,
    AlertQueryIsNotResultEntityQuery: 606,
    SameNameAlreadyExist: 607,
    Waiting: 608,
    AlertQueryNotHaveAlertDql: 609,
    UsedByEntityTableNameError: 610,
    BranchManagerDecisionRequired: 616,
    ResponseTypeofCurrentEventDiffersFromThatofCalledService: 617,
    BulkRecordListEmpty: 618,
    BulkFibaFailed: 619,
    FibaSuccessDbFailed: 620,
    DbSaveFailed: 621,
    BulkRecordLimitExceeded: 622
  },
  WEBGL_LIMIT: 500,
  INTERVALS: {
    GET_NOTIFICATION_INTERVAL_TIME: 60000,
    GET_SIB_TRACKING_NOTIFICATION_INTERVAL_TIME: 60000,
    SAVE_SCHEMA_INTERVAL_TIME: 300000,
    LAYOUT_SAVE_INTERVAL_TIME: 60000,
  },
  SCHEMA_EXPAND_POPUP_COUNT: 5,
  SVGCONTAINER_TOP: 205,  // navbar and tabs header height,
  SVGCONTAINER_TOP_WITHOUT_NAVBAR: 70,  //tabs headers height,
  SVGCONTAINER_HANDLE_AREA_X: 10,
  SVGCONTAINER_HANDLE_AREA_Y: 50,
  SVGCONTAINER_SELECTED_AREA_X: 10,
  SVGCONTAINER_SELECTED_AREA_Y: 195,
  SVGCONTAINER_SELECTED_AREA_HEIGHT_X: 13,
  SVGCONTAINER_SELECTED_AREA_HEIGHT_Y: 195,
  SCHEMA_SELECTION_AREA_LEFT_PADDING: 10,
  SCHEMA_SELECTION_AREA_BOTTOM_PADDING: 50,
  GEOGRAPHICAL_ANALYSIS_MAX_AREA_COUNT: 3,
  DEFAULT_TABLE_HEIGHT: 575,
  ALERT_ON_TABLE_HEIGHT: 400,
  DASHBOARD_EXPAND_ZOOM_LEVEL: 0.6,
  DASHBOARD_CENTER_ZOOM_LEVEL: 0.5,
  DASHBOARD_SELECTED_NODE_MAX_ZOOM_LEVEL: 3,
  MAX_PTS_PHOTO_COUNT: 30,
  PDF_MAX_EXPORT_ROWS: 100000,
  filterCounterText: "Tekrar Sayısı",
  repeatCountSymbolicAttrId: -1,
  lastnOperatorText: "lastn",
  OPENSTREET_MAP_LAYER_URL: "https://harita.pars.jandarma.gov.tr/styles/basic-preview/512/{z}/{x}/{y}.png",
  GOOGLE_STREET_MAP_LAYER_URL: 'http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}',
  GOOGLE_HYBRID_MAP_LAYER_URL: 'http://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}',
  GOOGLE_TERRAIN_MAP_LAYER_URL: 'http://{s}.google.com/vt/lyrs=p&x={x}&y={y}&z={z}',
  SHOW_ICONS_FOR_PERSON: false,
  staticFileUri: "/StaticFiles/AllIcons/",
  nullIconValue: "/StaticFiles/images/male.jpg",
  EMPTY_ICON_PATH: "SYSTEM/bos.png",
  lastDateOperator: ["last day", "last month", "last year", "last hour", "last minute"],
  operatorMapForTable: {
    String: [
      { text: localize("eşittir"), value: "=" },
      { text: localize("eşit değildir"), value: "!=" },
      { text: localize("liste içinde değil"), value: "not in" },
      { text: localize("liste içinde"), value: "in" },
      { text: localize("ile başlar"), value: "starts with" },
      { text: localize("ile biter"), value: "ends with" },
      { text: localize("içerir"), value: "contains" },
      { text: localize("içermez"), value: "not contains" },
      { text: localize("boş olsun"), value: "is null" },
      { text: localize("boş olmasın"), value: "is not null" }
    ],
    Numeric: [
      { text: localize("eşittir"), value: "=" },
      { text: localize("eşit değildir"), value: "!=" },
      { text: localize("liste içinde"), value: "in" },
      { text: localize("liste içinde değil"), value: "not in" },
      { text: localize("küçük"), value: "<" },
      { text: localize("büyük"), value: ">" },
      { text: localize("arasında"), value: "between" },
      { text: localize("eşit veya küçük"), value: "<=" },
      { text: localize("eşit veya büyük"), value: ">=" },
      { text: localize("boş olsun"), value: "is null" },
      { text: localize("boş olmasın"), value: "is not null" }
    ],
    Currency: [
      { text: localize("eşittir"), value: "=" },
      { text: localize("eşit değildir"), value: "!=" },
      { text: localize("liste içinde"), value: "in" },
      { text: localize("liste içinde değil"), value: "not in" },
      { text: localize("küçük"), value: "<" },
      { text: localize("büyük"), value: ">" },
      { text: localize("arasında"), value: "between" },
      { text: localize("eşit veya küçük"), value: "<=" },
      { text: localize("eşit veya büyük"), value: ">=" },
      { text: localize("boş olsun"), value: "is null" },
      { text: localize("boş olmasın"), value: "is not null" }
    ],
    Boolean: [
      { text: localize("eşittir"), value: "=" },
    ],
    Date: [
      { text: localize("eşittir"), value: "=" },
      { text: localize("eşit değildir"), value: "!=" },
      { text: localize("daha önce"), value: "<" },
      { text: localize("daha sonra"), value: ">" },
      { text: localize("arasında"), value: "between" },
      { text: localize("aynı veya daha önce"), value: "<=" },
      { text: localize("aynı veya daha sonra"), value: ">=" },
      { text: localize("boş olsun"), value: "is null" },
      { text: localize("boş olmasın"), value: "is not null" },
      { text: localize("son gün"), value: "last day" },
      { text: localize("son ay"), value: "last month" },
      { text: localize("son yıl"), value: "last year" },
      { text: localize("previousWeek"), value: "previous week" },
      { text: localize("previousMonth"), value: "previous month" },
      { text: localize("last n"), value: "lastn" },
    ],
    Datetime: [
      { text: localize("eşittir"), value: "=" },
      { text: localize("eşit değildir"), value: "!=" },
      { text: localize("daha önce"), value: "<" },
      { text: localize("daha sonra"), value: ">" },
      { text: localize("arasında"), value: "between" },
      { text: localize("aynı veya daha önce"), value: "<=" },
      { text: localize("aynı veya daha sonra"), value: ">=" },
      { text: localize("boş olsun"), value: "is null" },
      { text: localize("boş olmasın"), value: "is not null" },
      { text: localize("son gün"), value: "last day" },
      { text: localize("son ay"), value: "last month" },
      { text: localize("son yıl"), value: "last year" },
      { text: localize("son saat"), value: "last hour" },
      { text: localize("son dakika"), value: "last minute" },
      { text: localize("previousWeek"), value: "previous week" },
      { text: localize("previousMonth"), value: "previous month" },
      { text: localize("last n"), value: "lastn" },
    ],
    Parameter: [
      { text: localize("liste içinde"), value: "in" },
      { text: localize("liste içinde değil"), value: "not in" },
    ]
  },
  operatorMap: {
    String: [
      { text: localize("eşittir"), value: "=" },
      { text: localize("eşit değildir"), value: "!=" },
      { text: localize("liste içinde değil"), value: "not in" },
      { text: localize("liste içinde"), value: "in" },
      { text: localize("ile başlar"), value: "starts with" },
      { text: localize("ile başlamaz"), value: "not starts with" },
      { text: localize("ile biter"), value: "ends with" },
      { text: localize("içerir"), value: "contains" },
      { text: localize("içermez"), value: "not contains" },
      { text: localize("boş olsun"), value: "is null" },
      { text: localize("boş olmasın"), value: "is not null" },
      { text: localize("benzer"), value: "similar" },
      { text: localize("içerir liste"), value: "inlike" },
      { text: localize("içermez liste"), value: "notinlike" },
      { text: localize("İle başlar liste"), value: "startswithlike" },
      { text: localize("ile başlamaz liste"), value: "notstartswithlike" },

    ],
    Numeric: [
      { text: localize("eşittir"), value: "=" },
      { text: localize("eşit değildir"), value: "!=" },
      { text: localize("liste içinde"), value: "in" },
      { text: localize("liste içinde değil"), value: "not in" },
      { text: localize("küçük"), value: "<" },
      { text: localize("büyük"), value: ">" },
      { text: localize("arasında"), value: "between" },
      { text: localize("eşit veya küçük"), value: "<=" },
      { text: localize("eşit veya büyük"), value: ">=" },
      { text: localize("boş olsun"), value: "is null" },
      { text: localize("boş olmasın"), value: "is not null" }
    ],
    Currency: [
      { text: localize("eşittir"), value: "=" },
      { text: localize("eşit değildir"), value: "!=" },
      { text: localize("liste içinde"), value: "in" },
      { text: localize("liste içinde değil"), value: "not in" },
      { text: localize("küçük"), value: "<" },
      { text: localize("büyük"), value: ">" },
      { text: localize("arasında"), value: "between" },
      { text: localize("eşit veya küçük"), value: "<=" },
      { text: localize("eşit veya büyük"), value: ">=" },
      { text: localize("boş olsun"), value: "is null" },
      { text: localize("boş olmasın"), value: "is not null" }
    ],
    Date: [
      { text: localize("eşittir"), value: "=" },
      { text: localize("eşit değildir"), value: "!=" },
      { text: localize("daha önce"), value: "<" },
      { text: localize("daha sonra"), value: ">" },
      { text: localize("arasında"), value: "between" },
      { text: localize("aynı veya daha önce"), value: "<=" },
      { text: localize("aynı veya daha sonra"), value: ">=" },
      { text: localize("boş olsun"), value: "is null" },
      { text: localize("boş olmasın"), value: "is not null" },
      { text: localize("son gün"), value: "last day" },
      { text: localize("son ay"), value: "last month" },
      { text: localize("son yıl"), value: "last year" },
      { text: localize("previousWeek"), value: "previous week" },
      { text: localize("previousMonth"), value: "previous month" },
      { text: localize("last n"), value: "lastn" },
    ],
    Datetime: [
      { text: localize("eşittir"), value: "=" },
      { text: localize("eşit değildir"), value: "!=" },
      { text: localize("daha önce"), value: "<" },
      { text: localize("daha sonra"), value: ">" },
      { text: localize("arasında"), value: "between" },
      { text: localize("aynı veya daha önce"), value: "<=" },
      { text: localize("aynı veya daha sonra"), value: ">=" },
      { text: localize("boş olsun"), value: "is null" },
      { text: localize("boş olmasın"), value: "is not null" },
      { text: localize("son gün"), value: "last day" },
      { text: localize("son ay"), value: "last month" },
      { text: localize("son yıl"), value: "last year" },
      { text: localize("son saat"), value: "last hour" },
      { text: localize("son dakika"), value: "last minute" },
      { text: localize("previousWeek"), value: "previous week" },
      { text: localize("previousMonth"), value: "previous month" },
      { text: localize("last n"), value: "lastn" },
    ],
    Parameter: [
      { text: localize("liste içinde"), value: "in" },
      { text: localize("liste içinde değil"), value: "not in" },
      { text: localize("boş olsun"), value: "is null" },
      { text: localize("boş olmasın"), value: "is not null" },
    ],
    DynamicParameter: [
      { text: localize("eşittir"), value: "=" },
      { text: localize("eşit değildir"), value: "!=" },
      { text: localize("benzer"), value: "similar" }
    ],
    DynamicStringParameter: [
      { text: localize("eşittir"), value: "=" },
      { text: localize("eşit değildir"), value: "!=" },
      { text: localize("içerir"), value: "contains" },
      { text: localize("içermez"), value: "not contains" },
      { text: localize("içerir liste"), value: "inlike" },
      { text: localize("içermez liste"), value: "notinlike" },
      { text: localize("İle başlar liste"), value: "startswithlike" },
      { text: localize("ile başlamaz liste"), value: "notstartswithlike" },
    ],
    DynamicDateParameter: [
      { text: localize("eşittir"), value: "=" },
      { text: localize("eşit değildir"), value: "!=" },
      { text: localize("daha önce"), value: "<" },
      { text: localize("daha sonra"), value: ">" },
      { text: localize("arasında"), value: "between" },
      { text: localize("aynı veya daha önce"), value: "<=" },
      { text: localize("aynı veya daha sonra"), value: ">=" },
    ],
    DynamicNumericParameter: [
      { text: localize("eşittir"), value: "=" },
      { text: localize("eşit değildir"), value: "!=" },
      { text: localize("küçük"), value: "<" },
      { text: localize("büyük"), value: ">" },
      { text: localize("arasında"), value: "between" },
      { text: localize("eşit veya küçük"), value: "<=" },
      { text: localize("eşit veya büyük"), value: ">=" },
    ],
    "Tekrar Sayısı": [
      { text: localize("eşittir"), value: "=" },
      { text: localize("eşit değildir"), value: "!=" },
      { text: localize("daha az"), value: "<" },
      { text: localize("daha fazla"), value: ">" },
      { text: localize("arasında"), value: "between" },
      { text: localize("aynı veya daha az"), value: "<=" },
      { text: localize("aynı veya daha fazla"), value: ">=" }
    ],
    Boolean: [
      { text: localize("eşittir"), value: "=" },
      { text: localize("eşit değildir"), value: "!=" },
      { text: localize("boş olsun"), value: "is null" },
      { text: localize("boş olmasın"), value: "is not null" }
    ]
  },
  transOperatorMap: {
    [localize("eşittir")]: "=",
    [localize("eşit değildir")]: "!=",
    "=": localize("eşittir"),
    "!=": localize("eşit değildir"),
    [localize("daha sonra")]: ">",
    [localize("daha önce")]: "<",
    ">": localize("daha sonra"),
    "<": localize("daha önce"),
    ">=": localize("aynı veya daha sonra"),
    "<=": localize("aynı veya daha önce"),
    [localize("aynı veya daha sonra")]: ">=",
    [localize("aynı veya daha önce")]: "<=",
    [localize("arasında")]: "between",
    "between": localize("arasında"),
    [localize("liste içinde değil")]: "not in",
    [localize("liste içinde")]: "in",
    [localize("ile başlar")]: "starts with",
    [localize("ile başlamaz")]: "not starts with",
    [localize("ile biter")]: "ends with",
    [localize("içerir")]: "contains",
    [localize("içermez")]: "not contains",
    "not in": localize("liste içinde değil"),
    "in": localize("liste içinde"),
    "starts with": localize("ile başlar"),
    "not starts with": localize("ile başlamaz"),
    "ends with": localize("ile biter"),
    "contains": localize("içerir"),
    "not contains": localize("içermez"),
    [localize("boş olsun")]: "is null",
    [localize("boş olmasın")]: "is not null",
    "is null": localize("boş olsun"),
    "is not null": localize("boş olmasın"),
    [localize("son gün")]: "last day",
    [localize("son ay")]: "last month",
    [localize("last n")]: "lastn",
    [localize("top n")]: "topn",
    [localize("son yıl")]: "last year",
    [localize("son saat")]: "last hour",
    "last day": localize("son gün"),
    "last month": localize("son ay"),
    "last year": localize("son yıl"),
    "last hour": localize("son saat"),
    "lastn": localize("last n"),
    "topn": localize("top n"),
    [localize("son dakika")]: "last minute",
    "last minute": localize("son dakika"),
    [localize("benzer")]: "similar",
    "similar": localize("benzer"),
    [localize("içerir liste")]: "inlike",
    "inlike": localize("içerir liste"),
    [localize("içermez liste")]: "notinlike",
    "notinlike": localize("içermez liste"),
    [localize("İle başlar liste")]: "startswithlike",
    "startswithlike": localize("İle başlar liste"),
    [localize("ile başlamaz liste")]: "notstartswithlike",
    "notstartswithlike": localize("ile başlamaz liste"),
    [localize("previousWeek")]: "previous week",
    "previous week": localize("previousWeek"),
    [localize("previousMonth")]: "previous month",
    "previous month": localize("previousMonth")
  },
  transRepeatOperatorMap: {
    [localize("eşittir")]: "=",
    [localize("eşit değildir")]: "!=",
    "=": localize("eşittir"),
    "!=": localize("eşit değildir"),
    "<": localize("daha az"),
    ">": localize("daha fazla"),
    [localize("daha az")]: "<",
    [localize("daha fazla")]: ">",
    [localize("arasında")]: "between",
    "between": localize("arasında"),
    ">=": localize("aynı veya daha fazla"),
    "<=": localize("aynı veya daha az"),
    [localize("aynı veya daha fazla")]: ">=",
    [localize("aynı veya daha az")]: "<=",
  },
  transNumericOperatorMap: {
    [localize("eşittir")]: "=",
    [localize("eşit değildir")]: "!=",
    "=": localize("eşittir"),
    "!=": localize("eşit değildir"),
    "not in": localize("liste içinde değil"),
    "in": localize("liste içinde"),
    [localize("liste içinde değil")]: "not in",
    [localize("liste içinde")]: "in",
    "<": localize("küçük"),
    ">": localize("büyük"),
    [localize("küçük")]: "<",
    [localize("büyük")]: ">",
    [localize("arasında")]: "between",
    "between": localize("arasında"),
    ">=": localize("eşit veya büyük"),
    "<=": localize("eşit veya küçük"),
    [localize("eşit veya büyük")]: ">=",
    [localize("eşit veya küçük")]: "<=",
    [localize("boş olsun")]: "is null",
    [localize("boş olmasın")]: "is not null",
    "is null": localize("boş olsun"),
    "is not null": localize("boş olmasın"),
    [localize("top n")]: "topn",
    "topn": localize("top n")
  },
  topNFilterObject: { text: localize("top n"), value: "topn" },
  scenarioApproveStatus: [
    { text: localize("Onaylandı"), value: "true" },
    { text: localize("Onaylanmadı"), value: "false" },
  ],
  intelligenceStatus: [
    { text: "➖", value: "0" },
    { text: "✔️", value: "1" },
    { text: "❌", value: "2" },
  ],
  HTS_COLUMN_TYPES: {
    "SIRA NO": "index",
    "NUMARA": "number",
    "TİP": "type",
    "DİĞER NUMARA": "otherNumber",
    "TARİH": "date",
    "SÜRE": "time",
    "İsim Soyisim ( Diğer Numara)": "name",
    "TC Kimlik No (Diğer Numara)": "personId",
    "IMEI": "imei",
    "BAZ (Numara)": "base",
    "DURUM": "status",
    "AD": "name",
    "SOYAD": "surname",
    "TC KİMLİK NO": "personId",
    "KAYNAK IP": "sourceIp",
    "HEDEF IP": "targetIp",
    "GÖNDERME BOYUTU (Byte)": "uploadSize",
    "İNDİRME BOYUTU (Byte)": "downloadSize"
  },
  GRAPH_TEXT_LIMIT: 50,
  NEW_ADDED_NODES_FOR_PIN_LIMIT: 2000,
  SUCCESS_COUNT_DOWN: 2000,
  WARNING_COUNT_DOWN: 2000,
  CANCEL_COUNT_DOWN: 2000,
  FACE_QUERY_MIN_SIMILARITY_PERCENT: 50,
  POSSIBLE_ROUTE_ENTITY_NAME: "MuhtemelRota",
  UNDO_REDO_LIMIT: 10,
  PTS_FILTER_ATTRS: {
    plate: "PLAKA",
    city: "İl Adı",
    county: "İlçe Adı",
    pts: "Kamera Adı",
    location: "Lokasyon",
    analizyer: "Analiz Yer"
  },
  MAP_POPUP_PROPERTIES: {
    "Geçiş Zamanı": true,
    PTSID: true,
    KAMERAID: true,
    ILILCE: true,
    Lokasyon: true,
    PLAKA: true,
    SASENO: true,
    KOORDINATX: true,
    KOORDINATY: true,
  },
  GEOGRAPHICAL_ANALYSIS_ID_ATTR_NAME: "Lokasyon",
  GEOGRAPHICAL_ANALYSIS_CAMERA_ID_ATTR_NAME: "KAMERAID",
  GEOGRAPHICAL_ANALYSIS_ATTR_NAME_LIST: { City: "PTS NRK İl Kodu", County: "PTS NRK İlce Kodu", Location: "PTS NRK Lokasyon Kodu", Camera: "KAMERAID" },
  GEOGRAPHICAL_ANALYSIS_UNIQUE_ATTR_NAME: "kamerasirano",
  ENTITY_TYPES: {
    NODE_TYPE: 1,
    EDGE_TYPE: 2,
    PARAMETER_TYPE: 3,
    ADDITIONAL_NODE_TYPE: 4,
    ONTHEFLY_ENTITY: 5,
    STACK_ENTITY: 6,
    STACK_ENTITY_EDGE: 7,
    PARENT_ENTITY: 8
  },
  ENTITY_TYPE_NAMES: {
    NODE: "Node",
    EDGE: "Edge",
    PARAMETER: "Parameter",
    ADDITIONAL_NODE: "AdditionalNode"
  },
  SUSPICIOUS_CATEGORY_UNIQUE_VALUE: "PRMKOD",
  WRITABLE_DATA_FAVORITE_BUTTON_VALUE: "writableData",
  ADDITIONAL_ENTITY_NAME: "Ekkisi",
  PERSON_ENTITY_NAME: "KISI", // daha sonra dinamikleştirilecek
  CUSTOMER_ENTITY_NAME: "CUSTOMER",
  TRANSFER_ENTITY_NAME: "Transfer",
  SECOND_CUSTOMER_ENTITY_NAME: "Alıcı",
  SECOND_PERSON_ENTITY_NAME: "Akrabası",
  FORMER_PARTNER_ENTITY_NAME: "Eski Eşi",
  FORMER_PARTNER_EDGE_NAME: "Eski Eş",
  FOREIGNER_ENTITY_NAME: "YabanciKisi",
  CAR_RENT_ENTITY_NAME: "Kiralama",
  ACCOMMODATION_ENTITY_NAME: "KONAKLAMA",
  ACCOMMODATION_2_ENTITY_NAME: "Konaklama2",
  CAR_ENTITY_NAME: "ARAC",
  CAMERA_ENTITY_NAME: "PTSKAMERA",
  PTS_ENTITY_NAME: "PTS",
  PTS_VIEW_ENTITY_NAME: "PTSView",
  PTS_CAM_ENTITY_NAME: "PTSKAMERASI",
  REGISTRY_CAR_ENTITY_NAME: "ARACI",
  OLD_CAR_ENTITY_NAME: "ESKIARACI",
  MOBILE_CAR_ENTITY_NAME: "MobilAracSahisSorgu",
  COMPANY_CAR_ENTITY_NAME: "SIRKETARACI",
  GUILTY_ENTITY_NAME: "OLAYSUPHELI",
  TRANSITION_ENTITY_NAME: "PTSGECIS",
  NEXT_PASS_ENTITY_NAME: "SonrakiGecis",
  BUS_ENTITY_NAME: "KARAYOLU",
  BUS_RIDE_ENTITY_NAME: "OTOBUSYOLCULUGU",
  FIRM_ENTITY_NAME: "Firma",
  COMPANY_ENTITY_NAME: "TUZELKISI",
  SECOND_COMPANY_ENTITY_NAME: "Tüzel Kisi",
  REGISTRY_COMPANY_ENTITY_NAME: "Sirketi",
  CUSTOMS_ENTITY_NAME: "Gumruk",
  CUSTOMS_PASS_ENTITY_NAME: "GumrukGecisi",
  COORDINATE_LIST_ATTR_NAME: "KoordinatListesi",
  FUEL_ENTITY_NAME: "Yakit",
  FUEL_EDGE_ENTITY_NAME: "Yakiti",
  API_ENTITY_NAME: "UCUSYOLCUDETAY",
  FLIGHT_ENTITY_NAME: "UCUS",
  WARNING_PROJECT_ENTITY_NAME: "İhbar Projesi",
  INFORMATION_NOTE_ENTITY_NAME: "Bilgi Notu",
  PROXY_ENTITY_NAME: "Vekalet",
  SECOND_PROXY_ENTITY_NAME: "Vekalet Alan",
  RENT_ENTITY_NAME: "ARACKIRA",
  TRAFFIC_CONTROL_ENTITY_NAME: "TRAFIKDENETLEMEKISI",
  KYC_ENTITY_NAME: "KYC",
  KYC_SCORE_ATTR_NAME: "KYC Skor",
  KYC_LONG_TEXT_ABBREVIATION: 35,
  TRAFFIC_CONTROL_DATE_ATTR_NAME: "Kontrol Tarihi",
  TRAFFIC_CONTROL_ATTR_NAME: "Kontrol Adı",
  TRAFFIC_CONTROL_CITY_ATTR_NAME: "İl Adı",
  MERNIS_ARCHIVE_CITY_ATTR_NAME: "Mernis İl Adı",
  CAR_ARCHIVE_RESOURCE_ATTR_NAME: "Arşiv Kaynak",
  OTEL_ENTITY_NAME: "OTEL",
  CRIME_ENTITY_NAME: "OLAY",
  CRIME_DETAIL_ENTITY_NAME: "OlayIcerik",
  DEVICE_ENTITY_NAME: "Device",
  DEVICE_ID_ATTR_NAME: "DeviceId",
  DIALOG_ENTITY_NAME: "CDIALOG",
  IMPORTANT_MESSAGE_ENTITY_NAME: "CDegerliMesaj",
  DIALOG_ID_ATTR_NAME: "CDIALOGID",
  EXTRAENTITYATTRS_WONT_SHOWN: ["Id", "EntityId", "CDegerliMesajId"],
  CUSTOMERSTATUS_ATTR_ALIAS: "Durum",
  CUSTOMER_STATUS_PRM_NAME: "PRMCUSTOMERSTATUS",
  CITY_PRM_NAME: "PrmIl",
  COUNTY_PRM_NAME: "PrmIlce",
  CRIMINAL_DATA_ANALYSIS_NAME: "analizdosyapersoneladsoyad",
  CRIMINAL_DATA_ANALYSIS_RANK: "analizdosyapersonelrutbe",
  CRIMINAL_DATA_ANALYSIS_CITY: "analizdosyapersonelil",
  CRIMINAL_DATA_UPDATE_DATE: "UPDATEDATE",
  CITY_PRM_DESCRIPTION: "PrmAciklama",
  CITY_PRM_CODE: "PrmIlKod",
  SIB_COUNTY_PRM_NAME: "PrmSibIlce",
  SIB_COUNTY_TWOZERO_PRM_NAME: "PrmSibIlce20",
  STATUS: {
    ACTIVE: "Aktif",
    PASSIVE: "Pasif"
  },
  TRAIN_ENTITY_NAME: "DEMIRYOLU",
  TRAIN_PASS_ENTITY_NAME: "DEMIRYOLUYOLCULUGU",
  PHONE_ENTITY_NAME: "TELEFON",
  PHONE_ENTITY_NAME_FOR_DEV: "Phone",
  SECOND_PHONE_ENTITY_NAME: "Other Phone",
  PERSON_PHONE_ENTITY_NAME: "TELEFONU",
  LAST_USER_ENTITY_NAME: "SonKullananArac",
  CAR_ARCHIVE_ENTITY_NAME: "AracArsiv",
  CAR_ARCHIVE_EDGE_ENTITY_NAME: "AracArsivi",
  EFT_ENTITY_NAME: "EFT",
  HAVALE_ENTITY_NAME: "Havale",
  TRANSACTION_ENTITY_NAME: "TRANSACTION",
  TRANSACTION_TIME_ATTR_NAME: "TRANSACTIONTIME",
  CURRENCY_AMOUNT_ATTR_NAME: "CURRENCYAMOUNT",
  CURRENCY_ATTR_NAME: "CURRENCY",
  TRANSACTION_DATE_ATTR_NAME: "TRANSACTIONTIME",
  LEGAL_ID_ATTR_NAME: "LEGALID",
  VKN_ATTR_NAME: "VKN",
  YKN_ATTR_NAME: "YKN",
  UNVAN_ATTR_NAME: "UNVAN",
  GENDER_ATTR_NAME: "GENDER",
  UYRUK_ATTR_NAME: "UYRUKDESC",
  HTS_MAX_DIST_BETWEEN_SAME_BASES: 1000,
  HTS_MAX_DIST_BETWEEN_COORDINATE_BASES: 10000,
  HTS_MAX_TIME_INTERVAL_SAME_BASES: 30,
  HTS_MIN_TIME_INTERVAL_COMMUNICATION_INTERRUPTION: 180,
  HTS_INDEX_NAME: "SIRA NO",
  HTS_ENTITY_NAME: "HTS",
  HTS_DETAIL_ENTITY_NAME: "HTSDetay",
  HTS_EDGE_ENTITY_NAME: "HTSsi",
  HTS_PERSON_ENTITY_NAME: "HtsKisi",
  HTS_PERSON_EDGE_ENTITY_NAME: "HtsKisiKenar",
  HTS_PERSON_CALLS_SUB_NODE_NAME: "İrtibat",
  HTS_PERSON_SAME_CALLS_SUB_NODE_NAME: "Ortak İrtibat",
  HTS_PERSON_BETWEEN_TARGETS_SAME_CALLS_SUB_NODE_NAME: "Hedef Ortak İrtibat",
  HTS_PERSON_BETWEEN_TWO_GROUPS_SAME_CALLS_SUB_NODE_NAME: "İki Hedef Grubu Ortak İrtibat",
  HTS_PERSON_CALLS_SUB_EDGE_NAME: "İrtibat Kenar",
  HTS_PERSON_SAME_CALLS_SUB_EDGE_NAME: "Ortak İrtibat Kenar",
  HTS_PERSON_BETWEEN_TARGETS_SAME_CALLS_SUB_EDGE_NAME: "Hedef Ortak İrtibat Kenar",
  HTS_PERSON_BETWEEN_TWO_GROUPS_SAME_CALLS_SUB_EDGE_NAME: "İki Hedef Grubu Ortak İrtibat Kenar",
  UNKNOWN_ENTITY_NAME: "Bilinmeyen",
  PROPERTY_ATTR_NAME: "Özellik",
  ATM_ENTITY_NAME: "ATM",
  ATM_ID_ATTR_NAME: "ATM Id",
  ATM_MOVEMENT_EDGE_ENTITY_NAME: "ATMHareket",
  BANK_ACCOUNT_ENTITY_NAME: "ACCOUNT",
  DB_NULL_DATETIME_VALUE: "01/01/0001 00:00:00",
  ACCOUNT_ENTITY_NAME: "Hesap",
  AMOUNT_COLUMN_NAME: "Tutar",
  ACCOUNT_EDGE_ENTITY_NAME: "Hesabi",
  SECOND_ACCOUNT_ENTITY_NAME: "Karşı Hesap",
  FIRM_ACCOUNT_ENTITY_NAME: "HesabiFirma",
  CENTRALITY_ANALYSIS_EDGE: "Yogunluk",
  CENTRALITY_ANALYSIS_SUB_EDGE: "CentralityAnalysisSubEdge",
  CENTRALITY_ANALYSIS_SUB_NODE: "Yoğunluk",
  CENTRALITY_ANALYSIS_SUB_NODE_FONT_SIZE: 30,
  CENTRALITY_ANALYSIS_COUNT_ATTR_NAME: "Tekrar Sayısı",
  CENTRALITY_ANALYSIS_THICKNESS_ATTR_NAME: "Kalınlık",
  CENTRALITY_ANALYSIS_MAIN_ENTITY: "Kisi",
  CENTRALITY_ANALYSIS_EDGE_WIDTH_MULTIPLIER: 2,
  CENTRALITY_ANALYSIS_EDGE_COLOR: "#00A7E1",
  CENTRALITY_ANALYSIS_SUB_NODE_ATTRIBUTES: { 'parentId': true, 'relatedEdges': true, 'relatedNodes': true },
  GROUP_NODE_ENTITY_ALIAS: "Özelleştirilmiş",
  GROUP_NODE_ENTITY_ICON: "YENİ/gruplandırma.png",
  GROUP_NODE_ENTITY_COLOR: "#C778EAFF",
  GROUP_EDGE_ENTITY_NAME: "GroupEdge",
  GROUP_EDGE_ENTITY_ALIAS: "Gruplandırılmış Kenar",
  GROUP_SUB_NODE_ENTITY_ALIAS: "Gruplandırılmış",
  GROUP_SUB_NODE_ENTITY_NAME: "GroupSubNode",
  GROUP_SUB_EDGE_ENTITY_NAME: "GroupSubEdge",
  CUSTOM_GROUP_NODE_ENTITY_NAME: "customGroupNode",
  CUSTOM_NODE_ENTITY_NAME: "customNode",
  CUSTOM_EDGE_ENTITY_NAME: "customLink",
  CUSTOM_GROUP_SUB_NODE: "customGroupSubNode",
  CUSTOM_SUB_NODE: "customSubNode",
  COUNT_SUB_ENTITY_NAME: "Adet",
  TOTAL_SUB_ENTITY_NAME: "Toplam",
  PASS_TIME_ATTR_NAME: "Geçiş Zamanı",
  PTS_ID: "PTSID",
  PLAKA_ATTR_NAME: "PLAKA",
  WAIT_TIME: "Geçiş Süresi",
  X_COORDINATE: "KOORDINATX",
  Y_COORDINATE: "KOORDINATY",
  NEXT_X_COORDINATE: "Sonraki X Koordinatı",
  NEXT_Y_COORDINATE: "Sonraki Y Koordinatı",
  COUNT_ATTR_NAME: "Adet",
  KAMERA_ID: "KameraId",
  ANALIZ_YER: "Analiz Yer",
  PERSON_ID_ATTR_NAME: "TCKIMLIKNO",
  CRIME_CONTENT_ATTR_NAME: "İçerik",
  CRIME_DATE_ATTR_NAME: "OLAYTARIH",
  CAR_ID_ATTR_NAME: "SASENO",
  PLATE_ATTR_NAME: "PLAKA",
  FUEL_DATE_ATTR_NAME: "Yakıt Tarihi",
  RENT_END_DATE_ATTR_NAME: "KIRAGELISTARIHI",
  RENT_START_DATE_ATTR_NAME: "KIRAALISTARIHI",
  RENT_DELIVER_DATE_ATTR_NAME: "Kira Geliş Günü",
  COMPANY_ID_ATTR_NAME: "VERGINO",
  NAME_SURNAME_ATTR_NAME: "ADSOYAD",
  COMPANY_NAME_ATTR_NAME: "FIRMAUNVANI",
  FIRM_ID_ATTR_NAME: "VergiNo",
  PERSON_CASE_ENTITY_NAME: "VakaDosyasiKisi",
  COMPANY_CASE_ENTITY_NAME: "VakaDosyasiFirma",
  CUSTOMER_CASE_ENTITY_NAME: "VakaDosyasi",
  CRIME_ID_ATTR_NAME: "OLAYID",
  CRIME_NAME_ATTR_NAME: "OLAYSUCKOD4",
  CRIME_TYPE_ATTR_NAME: "OLAYTUR",
  CRIME_DESCRIPTION: "OLAYSUPHELIID",
  CITY_COUNTY_ATTR_NAME: "İl İlçe",
  FUEL_TYPE_ATTR_NAME: "Yakıt Türü",
  FUEL_QUANTITY_ATTR_NAME: "Yakıt Miktarı",
  FUEL_BUY_DAY_ATTR_NAME: "Yakıt Alış Günü",
  CAR_MODEL_YEAR_ATTR_NAME: "Model Yılı",
  CAR_TYPE_ATTR_NAME: "Araç Türü",
  CAR_MOTOR_NO_ATTR_NAME: "Motor No",
  CITY_NAME_ATTR_NAME: "İl Adı",
  COUNTY_NAME_ATTR_NAME: "İlçe Adı",
  BETWEEN_TWO_CARS_TIME: "İki Araç Arası En Fazla Süre",
  MIN_CONFLICT_NUMBER: "En Az Çakışma Sayısı",
  START_TIME_ATTR_NAME: "Başlangıç Zamanı",
  END_TIME_ATTR_NAME: "Bitiş Zamanı",
  FOLLOWER_TYPE_ATTR_NAME: "Öncü Artçı Tipi",
  LOCATION_ATTR_NAME: "Lokasyon",
  REGISTRATION_DATE_ATTR_NAME: "TESCIL TARIHI",
  REGISTRATION_REASON_ATTR_NAME: "Tescil Nedeni",
  TARGET_PLATE_ATTR_NAME: "Hedef Plaka",
  CONFLICT_COUNT_ATTR_NAME: "Çakışma Sayısı",
  SCHEMA_COLORFUL_SUBNODE_TARGET_MAP: {
    "TRANSFER DETAY": "CUSTOMER_",
    "HavaleTutar": "Hesap_",
    "EFTTutar": "Hesap_"
  },
  SCHEMA_COLORFUL_SUBNODE_COLOR_MAP: {
    "TRANSFER DETAY": "#FF0000",
    "HavaleTutar": "#FF0000",
    "EFTTutar": "#FF00FF"
  },
  ADDITIONAL_ENTITY_DATE_ATTR_KEYWORD: "_WITHDATE",
  SCENARIO_IDS_ATTR: "ScenarioIdForList",
  ANALYSIS_PBIK_ATTR: "analizdosyapersonelpbik",
  ANALYSIS_CITY_ATTR: "adlianalizolusturanil",
  PERSON_REGISTRATION_CITY: "NFSILKOD",
  PERSON_REGISTRATION_COUNTY: "NUFUSILCEKOD",
  CRIME_TYPE_NARKOTIK: "NARKOTIK",
  MY_SCENARIOS_TAB_NAME: localize("Senaryolarım"),
  SCENARIOS_TAB_NAME: localize("Senaryolar"),
  SCENARIO_RULE_NAME: "Senaryo",
  KYC_RULE_NAME: "KycQuery",
  HIGHLIGHT_RULE_NAME: "Şüpheli İşlem Bildirimi", // TODO ktolga: serverda da bu isimle tuttuğumuz için localize yapamıyoruz. Nasıl yapılacağı konuşulmalı
  TIME_EXPIRED_STRING_FOR_ATS: "SÜRESİ DOLDU!",
  MAX_QUERY_FILTER_COUNT: 999,
  CONCATENATE_OPERATOR: " - ",
  JANDARMA_ENV_NAME: "Jandarma",
  JANDARMA_ATLAS_API_KEY: "a13lcbVNyx0SxfT7ZT3T7sHiflFyXl6e",
  LOCAL_STORAGE_ITEMS: {
    entityStatistics: "entityStatistics",
    entityActions: "entityActions",
    nodeEdgeMapping: "nodeEdgeMapping",
    access_token: "access_token",
    entitiesWithAttributes: "entitiesWithAttributes",
    subEntities: "subEntities",
    visibleHeaders: "visibleHeaders",
    commonEntities: "commonEntities",
    entityCharacteristics: "entityCharacteristics",
    copiedMap: "copiedMap",
    subEntitiesDetailMap: "subEntitiesDetailMap",
    entityMappings: "entityMappings",
    approvedObligationDialog: "approvedObligationDialog",
    parameterEntityMaps: "parameterEntityMaps",
    entityAttrIdNameMap: "entityAttrIdNameMap",
    entityNameEntityIdMap: "entityNameEntityIdMap",
    tableDefaultOrderMap: "tableDefaultOrderMap",
    outSubEntities: "outSubEntities",
    nodeEdgeMappingFilterables: "nodeEdgeMappingFilterables",
    nodeEdgeMappingVisibles: "nodeEdgeMappingVisibles",
    entityAliasMap: "entityAliasMap",
    notNotifiedCount: "notNotifiedCount",
    notNotifiedChatCount: "notNotifiedChatCount",
    assignedAlertCount: "assignedAlertCount",
    userName: "userName",
    perms: "perms",
    wholeExpandData: "wholeExpandData",
    small_token: "small_token",
    autosavedSchemaNames: "autosavedSchemaNames",
    autoExpandEntityActions: "autoExpandEntityActions",
    transferGroupData: "transferGroupData",
    tabHistory: "tabHistory",
    sso_key: "sso_key",
    clientSettings: "clientSettings",
    saveAsStringMap: "saveAsStringMap",
    autoInOperator: "autoInOperator",
    sibPageFlag: "sibPageFlag",
    sibFromAlertsVersion: "sibFromAlertsVersion",
    applicationMode: "applicationMode",
    selectedApp: "selectedApp",
    sibTrackingRemainingDay: "sibTrackingRemainingDay",
    relatedApp: "relatedApp",
    sibExcelUploadId: "sibExcelUploadId"
  },
  // LocalStorage items that should not be deleted will be added here.
  DONT_REMOVE_LOCALE_STORAGE_ITEMS: {},
  DONT_REMOVE_LOCALE_STORAGE_ITEMS_ON_SYNC: {
    access_token: "access_token",
    userName: "userName",
    perms: "perms",
    small_token: "small_token",
    sso_key: "sso_key",
    tabHistory: "tabHistory",
    notNotifiedCount: "notNotifiedCount",
    notNotifiedChatCount: "notNotifiedChatCount",
    assignedAlertCount: "assignedAlertCount",
    applicationMode: "applicationMode",
    selectedApp: "selectedApp",
    relatedApp: "relatedApp"
  },
  SESSION_STORAGE_ITEMS: {
    analysisId: "analysisId",
    analysisQueryId: "analysisQueryId",
    analysisReason: "analysisReason",
  },
  Z_INDEXES: {
    bootstrapModalDefault: 1040, //cannot be changed
    vuetifyModalDefault: 202,//cannot be changed
    vueModal: 201,
    fraudNavbar: 200,
    topNavbar: 199,
    queryNavbar: 198,
    schemaNavbar: 197,
    viewTabNavbar: 196,
    map: 195,
    buttonsOnMap: 196,
    min: 1,
    alert: 9999,
    addNodeDialog: 999,
    iconSelector: 1000,
    tableOverlay: 99999
  },
  NAVBAR_ITEMS: {
    "analysis": localize("navbar.analysis"),
    "scenarios": localize("navbar.scenarios"),
    "dataOperations": localize("navbar.dataOperations"),
    "caseManagement": localize("navbar.caseManagement"),
    "suspiciousTransaction": localize("navbar.suspiciousTransaction"),
    "dynamicDescription": localize("navbar.dynamicDescription"),
    "statistics": localize("navbar.statistics"),
    "scenarioAlerts": localize("navbar.scenarioAlerts"),
    "kyc": localize("navbar.KYC/CDD"),
    "management": localize("navbar.management"),
    "preparedQueries": localize("navbar.preparedQueries"),
    "serviceQuery": localize("navbar.serviceQuery"),
    "artificialIntelligence": localize("navbar.artificialIntelligence"),
    "similarCustomer": localize("navbar.similarCustomer"),
    "dtgraph": localize("navbar.dtgraph"),
    "autoAlertAssign": localize("navbar.autoAlertAssign"),
    "atsQuery": localize("navbar.atsQuery"),
    "spaceGraph": localize("navbar.spaceGraph")
  },
  QUERY_TYPES: [
    {
      nameKey: "HIZLI SORUŞTURMA",
      type: "single",
      perm: "singleQuery",
      id: "single-query-button",
      icon: "/icon_images/hızlısorusturma_icon.png",
      caption: "Anlık erişim"
    },
    {
      nameKey: "DETAYLI SORUŞTURMA",
      type: "complex",
      perm: "complexQuery",
      id: "complex-query-button",
      icon: "/icon_images/detaylısorusturma_icon.svg",
      caption: "Derin analiz"
    },
    {
      nameKey: "ÇOKLU HIZLI SORUŞTURMA",
      type: "global",
      perm: "globalQuery",
      icon: "mdi-search-web"
    },
    {
      nameKey: "Müşteri Detay",
      type: "customerDetail",
      perm: "customerDetail",
      id: "customer-detail-button",
      icon: "/icon_images/varlikdetay_icon.svg",
      caption: "Zaman bazlı"
    },
    {
      nameKey: "sanctionAndPep",
      type: "sanctionAndPep",
      perm: "sanctionAndPep",
      id: "sanction-and-pep",
      icon: "/icon_images/sanctionpep_icon.svg"
    },
    // TAKİP SİSTEMİ ALTINDA BİRLEŞTİRİLDİ
    // { 
    //   nameKey: "atsQuery",
    //   type: "atsQuery",
    //   perm: "atsQuery",
    //   id: "plate-tracking-system",
    //   icon: "mdi-car-search"
    // },
    {
      nameKey: "trackingSystem.title",
      type: "trackingSystem",
      perm: "trackingSystem",
      id: "tracking-system",
      icon: "/icon_images/takipsistemi_icon.png",
      caption: "Gerçek zamanlı"
    },
    {
      nameKey: "compoundQuery",
      type: "compoundQuery",
      perm: "compoundQuery",
      id: "compound-query",
      icon: "/icon_images/bilesiksorgu_icon.png",
      caption: "Toplu veri"
    },
    {
      nameKey: "informationCard",
      type: "informationCard",
      perm: "informationCard",
      id: "information-card",
      icon: "/icon_images/bilgikarti_icon.png",
      caption: "Veri doğrulama"
    },
    {
      nameKey: "organizationTracking.title",
      type: "organizationTracking",
      perm: "organizationTracking",
      id: "organization-tracking",
      icon: "mdi-account-group-outline"
    },
    //GEÇİCİ OLARAK KAPATILDI
    // {
    //   nameKey: "KARŞILAŞTIRMA EŞLEŞTİRME",
    //   type: "comparator",
    //   perm: "comparisonQuery"
    // },
    {
      nameKey: "Coğrafi Analiz",
      type: "map",
      perm: "geographicalAnalysis",
      icon: "mdi-image-filter-hdr",
      caption: "Lokasyon bazlı"
    },
    {
      nameKey: "PTS Noktaları",
      type: "poi",
      perm: "pointsOfInterest",
      icon: "mdi-cctv"
    },
    {
      nameKey: "digitalTraces.title",
      type: "digitalTraces",
      perm: "digitalTraces",
      id: "digital-traces",
      icon: "mdi-shoe-print",
      caption: "Dijital ayak izi"
    },
    {
      nameKey: "faceRecognition.title",
      type: "faceRecognition",
      perm: `${permissionList.faceSearch},${permissionList.faceCompare},${permissionList.faceMultiSearch},${permissionList.faceDeepfake}`,
      icon: "mdi-shield-account"
    },
    {
      nameKey: "integratedQuery.title",
      type: "integratedQuery",
      perm: "integratedQuery",
      icon: "mdi-web"
    },
    {
      nameKey: "logRecords.title",
      type: "logRecords",
      perm: "logRecords",
      icon: "mdi-math-log",
      caption: "Sistem günlükleri"
    },
    {
      nameKey: "sqlEditor",
      type: "sqlEditor",
      perm: "sqlQuery",
      id: "sql-editor-button",
      icon: "mdi-database-search"
    },
    {
      nameKey: "YÜZ TANIMA",
      type: "face",
      perm: "faceQuery"
    },
    {
      nameKey: "HTS",
      type: "hts",
      perm: "htsQuery",
      icon: "mdi-phone-incoming-outgoing",
      caption: "Takip sistemi"
    },
    {
      nameKey: "MALİ ANALİZ",
      type: "financialAnalysis",
      perm: "financialAnalysisQuery",
      icon: "mdi-cash-multiple"
    },
    // TAKİP SİSTEMİ ALTINDA BİRLEŞTİRİLDİ
    // {
    //   nameKey "UYARI İKAZ",
    //   type: "warning",
    //   perm: "queryWarnings",
    //   icon: "mdi-alert"
    // },
    {
      nameKey: "ÖNCÜ ARTÇI",
      type: "followers",
      perm: "followers"
    },
    {
      nameKey: "ANLIK TAKİP",
      type: "momentaryFollowers",
      perm: "momentaryFollowersQuery",
      icon: "mdi-radar"
    },
    {
      nameKey: "YOL ANALİZİ",
      type: "heatMap",
      perm: "heatMapQuery",
      icon: "mdi-road"
    },
    {
      nameKey: "STORED COMMUNICATIONS",
      type: "storedCommunication",
      perm: "storedCommunicationQuery"
    }
  ],
  // TODO ktolga: tüm datatypelar constanttan okunmalı
  ATTR_DATA_TYPES: {
    String: "String",
    Numeric: "Numeric",
    Date: "Date",
    Datetime: "Datetime",
    Parameter: "Parameter",
    Currency: "Currency",
    PDF: "PDF",
    Image: "Image",
    Boolean: "Boolean",
    ByteArray: "ByteArray"
  },
  NUMERIC_DATA_TYPES: ["numeric", "currency", "number", "decimal", "int"],
  AGGREGATE: {
    METHODS: ["SUM", "COUNT", "COUNT_DISTINCT", "AVG", "MIN", "MAX"],
    DEFAULT_METHOD: "SUM",
    DEFAULT_ORDER_DIRECTION: "DESC",
    MIN_LIMIT: 1,
    MAX_LIMIT: 10000,
    COLUMN_PREFIX: "agg_",
    MAX_VISIBLE_CHIPS: 5
  },
  FILTER_TYPES: {
    dynamic: 1,
    static: 2,
    dynamicDate: 3,
    parameter: 4,
    expandValue: 5,
    predefined: 6
  },
  PREDEFINED_FILTER_TYPES: [
    { value: "scenarioId", type: "Numeric" },
    { value: "username", type: "String" },
    { value: "currentDate", type: "Date" },
    { value: "currentTime", type: "Datetime" }
  ],
  COLUMN_FILTER_TYPES: {
    clientSide: "clientSide",
    serverSide: "serverSide",
  },
  TABLE_COLOR_FILTER_UZUNBEKLEME: {
    background: {
      "gun": "255,0,0",
      "saat": "255,99,71",
    },
    color: {
      "gun": "white",
      "saat": "white",
    }
  },
  TABLE_COLOR_FILTER: {
    columnName: "Tür",
    columnValue: {
      "EGZOS": "coral",
      "NOTER": "orange",
      "GÜMRÜK": "violet",
      "YAKIT": "pink",
      "TRFK": "tan",
      "KİRA": "red"
    }
  },
  CATCHING_CASE_TYPES: [
    {
      value: 1,
      text: "Narkotik"
    },
    {
      value: 2,
      text: "Asayiş"
    },
    {
      value: 3,
      text: "TEM"
    },
    {
      value: 4,
      text: "KOM"
    },
    {
      value: 5,
      text: "Siber"
    },
    {
      value: 6,
      text: "Göç"
    },
  ],
  CATCHING_ANALYSIS_TYPES: [
    {
      value: 1,
      text: localize("Otel Analizi")
    },
    {
      value: 2,
      text: localize("Uçak Analizi")
    },
    {
      value: 3,
      text: localize("Otobüs Analizi")
    },
    {
      value: 4,
      text: localize("Kiralık Araç Analizi")
    },
    {
      value: 5,
      text: localize("Gümrük Analizi")
    },
    {
      value: 6,
      text: localize("Öncü-Artçı Analizi")
    },
    {
      value: 7,
      text: localize("Yakıt Analizi")
    },
    {
      value: 8,
      text: localize("Yeni Tescil")
    },
    {
      value: 9,
      text: localize("Coğrafi Analiz")
    },
    {
      value: 10,
      text: localize("Gemi Analizi")
    },
    {
      value: 11,
      text: localize("Tren Analizi")
    },
    {
      value: 12,
      text: localize("Olay Kayıtlı Analizi")
    },
    {
      value: 13,
      text: localize("Arşiv Analizi")
    },
    {
      value: 14,
      text: localize("Kargo Analizi")
    },
    {
      value: 15,
      text: localize("GBT Analizi")
    },
  ],
  KYC_GROUP_TYPES: [
    { text: localize("kyc.kycScore"), value: 1 },
    { text: localize("kyc.detailedSearch"), value: 2 }
  ],
  KYC_COMPLIANCE_CONTROL_RISK_OPTIONS: [
    { labelKey: "kyc.rfi.compilianceControl.low", value: "low" },
    { labelKey: "kyc.rfi.compilianceControl.medium", value: "medium" },
    { labelKey: "kyc.rfi.compilianceControl.high", value: "high" },
  ],
  KYC_COMPLIANCE_CONTROL_OPINION_OPTIONS: [
    { labelKey: "kyc.rfi.compilianceControl.realMatch", value: "realMatch" },
    { labelKey: "kyc.rfi.compilianceControl.uncertain", value: "uncertain" },
    { labelKey: "kyc.rfi.compilianceControl.falseMatch", value: "falseMatch" },
  ],
  KYC_BRANCHOPERATIONS_ACTION_OPTIONS: [
    { labelKey: "kyc.rfi.branchOperation.submitToExecutiveBoard", value: "submitToExecutiveBoard" },
    { labelKey: "kyc.rfi.branchOperation.cancelAccountOpening", value: "cancelAccountOpening" },
    { labelKey: "kyc.rfi.branchOperation.initiateMasakNotificationProcess", value: "initiateMasakNotificationProcess" },
  ],
  CATCHING_TYPES: {
    Establish: 0,
    Catch: 1
  },
  PLATE_TRACKING_ATTRIBUTES: {
    city: "KAMERAIL",// "İl Adı",
    county: "KAMERAILCE", //"İlçe Adı",
    location: "Lokasyon",
    camera: "KAMERAADI"
  },
  INITIAL_ATTRIBUTES: {
    CreatedByForList: "CreatedByForList",
    CreatedAtForList: "CreatedAtForList",
    UpdatedByForList: "UpdatedByForList",
    UpdatedAtForList: "UpdatedAtForList",
    ApprovedByForList: "ApprovedByForList",
    IsApprovedForList: "IsApprovedForList",
    IsDeleted: "IsDeleted"
  },
  CASE_INSERTION_TYPES: {
    node: 1,
    relation: 2
  },
  HTS_BASE_TYPE: {
    base: 1,
    counterBase: 2
  },
  HTS_PROCEDURE_TYPES: {
    connections: "İrtibatlar",
    commonConnections: "Ortak İrtibatlar",
    betweenTargetsConnections: "Hedefler Arası İrtibatlar",
    betweenTwoTargetGroupConnections: "İki Hedef Grubu Arası İrtibatlar",
    sameBase: "Ortak Bazlar",
    dailyCityInfo: "Günlük Şehir Bilgisi",
    dailyCountyInfo: "Günlük İlçe Bilgisi",
    mostUsedBase: "En Çok Kullanılan Bazlar",
    distanceBetweenCalls: "Görüşmeler Arası Mesafe",
    consecutiveCalls: "Hedefler Arası Ardışık Arama",
    callForwarding: "Arama Yönlendirme",
    SubscriberImei: "Hedef IMEI",
    SubscriberSameImeiUsage: "Hedef IMEI Ortak Kullanım",
    SubscriberSameImeiUsageDetail: "Hedef IMEI Ortak Kullanım Detay",
    OtherBaseSameImeiUsageDetail: "Karşı Baz Ortak IMEI Kullanım Detay",
    OtherBaseSameImeiUsage: "Karşı Baz Ortak IMEI Kullanım",
    OtherBaseSubscriberConnection: "Karşı Baz - Hedef İrtibat",
    CoordinateBasedConnection: "Koordinat Bazlı Görüşme",
    communicationInterruption: "İletişim Kesintileri"
  },
  HTS_INDEXES: {
    RECORD_TYPE: 2,
    NUMBER: 1
  },
  HTS_FILE_STATUS: {
    processing: 1,
    completed: 2,
    error: 3
  },
  HTS_DETAIL_STATUS: {
    new_record: 0,
    file_uploading: 1,
    file_uploaded: 2,
    cleaning: 3,
    ready_for_analysis: 4,
    base_inserting: 5,
  },
  FINANCIALANALYSIS_FILE_STATUS: {
    processing: 1,
    completed: 2,
    error: 3
  },
  FINANCIALANALYSIS_DETAIL_STATUS: {
    new_record: 0,
    file_uploading: 1,
    file_uploaded: 2,
    cleaning: 3,
    ready_for_analysis: 4
  },
  GA_LAST_REGISTRY_TIME: 90,
  PHOTO_QUERY_TYPE: {
    GetPhotoFromFace: 8,
    GetPhotoFromDashboard: 9
  },
  ATS_EXPLANATION_ATTR_LIST: { "ADSOYAD": true, "TCKIMLIKNO": true, "SASENO": true, "FIRMAUNVANI": true, "KULLANIMSEKLI": true },
  EXECUTION_TYPES:
  {
    SQL: 1,
    SoapService: 2,
    RestService: 4,
    Oracle: 3,
    Postgre: 5,
    ClickHouse: 6
  },
  NOT_SHOWN_ENTITY_MAP: {
    Gecis: true,
    Karisan: true
  },
  INTELLIGENCE_DATA_BANNED_ATTRS:
    [
      "EntityId",
      "EntityKeyAttribute",
      "EntityValueAttribute",
      "AdditionalEntityAttrKey",
      "AdditionalEntityAttrValue",
      "AdditionalEntityAttrNumberValue",
      "AdditionalEntityAttrDateValue",
      "AdditionalEntityStatus",
      "AdditionalEntityIsDeleted",
      "AdditionalEntityDate"
    ],
  GEOGRAPHICAL_ANALYSIS_COLOR_MAP: {
    refreshedCar: "red",
    rentalCar: "rgb(174, 255, 174)",
    newRegisteredCar: "rgb(130, 199, 240)"
  },
  SIB_CASE_ADDITION_TYPES: {
    addByEntity: 0,
    allEntitiesToSameCases: 1,
    allEntitiesToNewCase: 2
  },
  SIB_TRANSACTION_DATE_TYPES: {
    single: 1,
    multiple: 2
  },
  SIB_VERSION: "1.4",
  SIB_COLUMN_MAPPING: {
    finalText: "FINALTEXT",
    constant: "CONSTANT"
  },
  HISTORY_STATUS: {
    created: "Created",
    updated: "Updated",
    deleted: "Deleted",
    activated: "Activated",
    deactivated: "Deactivated",
    approved: "Approved",
    unapproved: "Unapproved",
    waitingForUpdateApprove: "WaitingForUpdateApprove",
    waitingForActivationApprove: "WaitingForActivationApprove",
    waitingForInactiveApprove: "WaitingForInactiveApprove",
    waitingForDeletionApprove: "WaitingForDeletionApprove",
    rejectDeletionApprove: "RejectDeletionApprove",
    rejectUpdateApprove: "RejectUpdateApprove",
    rejectActivationApprove: "RejectActivationApprove",
    rejectInactiveApprove: "RejectInactiveApprove",
    systemDeactivated: "SystemDeactivated"
  },
  NODE_POSITION: {
    target: "target",
    source: "source"
  },
  PERMISSIONS: permissionList,
  ALERT_STATE_PERMISSIONS: [
    { text: "Admin", value: "alertAdmin" },
    { text: "Kullanıcı", value: "alertUser" },
  ],
  ALERT_STATES: {
    "NEW": "NEW",
    "ASSIGNED": "ASSIGNED",
    "AUTO_ASSIGNED": "AUTO_ASSIGNED",
    "REVIEW": "REVIEW"
  },
  SHOW_SIB_BUTTON_STATES: {
    "REVIEW": true,
    "ASSIGNED": true,
    "AUTO_ASSIGNED": true
  },
  SHOW_EXPORT_SIB_BUTTON_STATES: {
    "REVIEW": true
  },
  SAME_ALERT_STATES_MAP: {
    "ASSIGNED": ["AUTO_ASSIGNED"],
    "AUTO_ASSIGNED": ["ASSIGNED"],
  },
  SHOW_SIB_PREVIEW_BUTTON_STATES: {
    "BLOCKED": true,
    "SIB_APPROVAL": true,
    "SIB_REJECTED": true
  },
  NONE_SIBS_STATES_MAP: ["SIB_APPROVAL", "SIB_CANDIDATE"],
  ROUTE_NAMES: {
    ANALYSIS_FROM_ALERTS: "AnalysisFromAlerts",
    SIB_FROM_ALERTS: "SibFromAlert",
    CUSTOMER_DETAILS: "CustomerDetails",
    SCHEMA_FROM_NOTIFICATION: "SchemaFromNotification"
  },
  SIB_ALERT_STATE: "İnceleniyor",
  SIB_ALERT_STATE_NAME: "REVIEW",
  SIB_APPROVAL_STATE: "SIB_APPROVAL",
  SIB_ALERT_HIGHLIGHT_ADD_AUTO: true,
  OPEN_PAGE_ON_NEW_TAB: false,
  NDB_ID: 99,
  LANGUAGES: {
    TR: "tr",
    EN: "en"
  },
  HTTPTYPES: {
    GET: "GET",
    POST: "POST",
    PUT: "PUT",
    DELETE: "DELETE"
  },
  HTTPRESTAUTHTYPES: {
    noAuth: 1,
    apiKey: 2,
    bearerToken: 3,
    basicAuth: 4,
    digestAuth: 5,
    oAuth_1_0: 6,
    oAuth_2_0: 7
  },
  HTTPRESTAUTHTYPEITEMS: [],
  HTTPRESTBODYTYPES:
  {
    none: 0,
    formData: 1,
    xWwwFormUrlEncoded: 2,
    rawText: 3,
    rawJavaScript: 4,
    rawJson: 5,
    rawHtml: 6,
    rawXml: 7
  },
  HTTPRESTBODYTYPESITEMS: [],
  ENTITYRESTMAPPINGVALUETYPES: {
    string: 0,
    numeric: 1,
    longNumeric: 2,
    decimal: 3,
    date: 4,
    datetime: 5,
    listOfString: 7,
    listOfNumeric: 8,
    listOfLongNumeric: 9,
    listOfDecimal: 10,
    listOfDate: 11,
    listOfDatetime: 12,
    listOfObject: 13
  },
  ENTITYRESTMAPPINGVALUETYPEITEMS: [],
  ENTITYRESTMAPPINGPARAMETERTYPES: {
    query: 0,
    header: 1,
    bodyFormData: 2,
    bodyXWwwFormUrlEncoded: 3,
    bodyRawJson: 4,
    authorization: 5,
    static: 6
  },
  ATTRIBUTE_COL_MAPPING: {
    String: [
      "varchar",
      "text",
      "char",
      "nvarchar",
      "nchar",
      "ntext",
      "varchar2",
      "nvarchar2",
      "long",
      "clob",
      "nclob",
      "character",
      "character varying"
    ],
    Numeric: [
      "int",
      "bigint",
      "decimal",
      "float",
      "smallint",
      "tinyint",
      "numeric",
      "real",
      "number",
      "integer",
      "pls_integer",
      "binary_float",
      "binary_double",
      "integer",
      "smallint",
      "numeric",
      "real",
      "double precision",
      "number"
    ],
    Date: ["date", "smalldatetime"],
    Datetime: [
      "datetime",
      "timestamp",
      "datetime2",
      "datetimeoffset",
      "timestamp with time zone",
      "timestamp with local time zone",
      "timestamp without time zone",
      "timestamp with time zone",
      "time",
      "time with time zone"
    ],
    Currency: ["money", "smallmoney", "money"],
    Boolean: ["bit", "boolean", "bool"],
    ByteArray: [
      "binary",
      "varbinary",
      "image",
      "varbinary(max)",
      "raw",
      "long raw",
      "blob",
      "bytea"
    ]
  },
  RESTMAPPINGSYSTEMPARAMETERTYPEITEMS: [],
  RESTMAPPINGSYSTEMPARAMETERTYPES: {
    description: "__description__",
    userName: "__username__",
    ruleId: "__ruleId__"
    // TODO ATI: aşağıdaki bilgiler şu an için giriş yapan kullanıcıda eklenmemiş, o yüzden comment out edildi.
    // userId: "__userId__",
    // userFullName: "__userfullname__"
  },
  DBERRORS: {
    uniqueConstraintError: "unique constraint"
  },
  FLAGS: [
    {
      title: "Türkçe",
      value: "tr",
    },
    {
      title: "Română",
      value: "ro",
    },
    {
      title: "English",
      value: "en",
    },
    {
      title: "Deutsch",
      value: "de",
    },
    {
      title: "Azərbaycan",
      value: "az",
    },
    {
      title: "العربية",
      value: "ar",
    },
    {
      title: "Русский",
      value: "ru",
    }
  ],
  ENABLED_LANGUAGES: [
    { title: "Türkçe", value: "tr" },
    { title: "English", value: "en" },
    { title: "Deutsch", value: "de" },
    { title: "Azərbaycan", value: "az" },
    { title: "Română", value: "ro" },
    { title: "العربية", value: "ar" },
    { title: "Русский", value: "ru" }
  ],
  CURRENCY_LOCALE_INFO: {
    en: { currencyTitle: "en-EN", currencyType: "USD" },
    tr: { currencyTitle: "tr-TR", currencyType: "TRY" },
    de: { currencyTitle: "de-DE", currencyType: "EUR" },
    az: { currencyTitle: "az-AZ", currencyType: "AZN" },
    ro: { currencyTitle: "ro-RO", currencyType: "RON" },
    ar: { currencyTitle: "ar-QA", currencyType: "QAR" },
    ru: { currencyTitle: "ru-RU", currencyType: "RUB" }
  },

  SHOW_OBLIGATION_TEXT_DIALOG: process.env.VUE_APP_ENVIRONMENT == 'Jandarma',
  PROJECT_NAME: (() => {
    switch (process.env.VUE_APP_ENVIRONMENT) {
      case 'Jandarma':
        return "PARS";
      case 'Gumruk':
        return "UMUT";
      default:
        return "Datactive";
    }
  })(),
  CUSTOMERDETAILENTITYNAME: "CUSTOMERSTATISTICS",
  SHOW_EXCEL_ROW_STRIPES: false,

  //Environment Separaments Contants - For Key-Map Operations
  ENV_COMPONENTS: {
    APP_WATERMARK: "APP_WATERMARK",
    ANALYSIS_ANNOUNCEMENTS: "ANALYSIS_ANNOUNCEMENTS",
    BOVERLAY_PARSNOTITLELOGO: "BOVERLAY_PARSNOTITLELOGO",
  },
  ENV_COMPONENT_MAPPING: {
    APP_WATERMARK: "WATERMARK",
    ANALYSIS_ANNOUNCEMENTS: "ANNOUNCEMENTS",
    BOVERLAY_PARSNOTITLELOGO: "PARSNOTITLELOGO",
  },

  ENV_ASSETS: {
    NAVBAR_LOGOASSET: "NAVBAR_LOGOASSET",
    NAVBARITEMS_LOGOASSET: "NAVBARITEMS_LOGOASSET",
    DASHBOARD_BG_IMAGE: "DASHBOARD_BG_IMAGE",
  },
  ENV_ASSET_MAPPING: {
    NAVBAR_LOGOASSET: "PARS_LOGO",
    NAVBARITEMS_LOGOASSET: "PARS_LOGO",
    DASHBOARD_BG_IMAGE: "BG_WATERMARK",
  },

  ENV_ASSETS_CLASSES: {
    NAVBAR_LOGOASSET_CLASS: "NAVBAR_LOGOASSET_CLASS",
    NAVBARITEMS_LOGOASSET_CLASS: "NAVBARITEMS_LOGOASSET_CLASS",
  },
  ENV_ASSETS_CLASSES_MAPPING: {
    NAVBAR_LOGOASSET_CLASS: "PARS_LOGO",
    NAVBARITEMS_LOGOASSET_CLASS: "PARS_LOGO",
  },
  ENV_THEMES: {
    APP_THEME: "APP_THEME",
  },
  ENV_THEME_MAPPING: {
    APP_THEME: "THEME",
  },

  BANKA_THEME: {
    primary: 'linear-gradient(135deg, #4C5C6B 13%, #202D3E 71%, #020B1A 100%)',
    primaryX: 'linear-gradient(90deg, #4C5C6B 13%, #202D3E 71%, #020B1A 100%)',
    secondary: 'linear-gradient(180deg, #2D97C5 10%, #143C68 100%)',
    tertiary: 'linear-gradient(135deg, #2D97C5 10%, #6DCEEA 100%)',
    tertiarySolid: '#2D97C5',
    activeTab: 'linear-gradient(135deg, #2D97C5 10%, #6DCEEA 100%)',
    sidebarBg: '#202D3E',
    sidebarBgHover: '#2a3a52',
    sidebarAccent: '#1a2535',
    sidebarArrow: '#2D97C5',
    submenuBg: '#292f3d',
    navItemHoverBg: 'linear-gradient(135deg, #2D97C5 10%, #6DCEEA 100%)',
    tableHeaderBg: '#2a3749',
    tableHeaderGradient: 'linear-gradient(180deg, #4C5C6B 13%, #202D3E 71%, #020B1A 100%)',
    tableAccent: '#60a5fa',
    tableRowHover: 'rgba(42, 55, 73, 0.045)',
    pageHeaderBg: 'linear-gradient(to bottom right, #2D97C5 10%, #6DCEEA 100%)',
    pageHeaderCardBg: 'linear-gradient(135deg, #4C5C6B 13%, #202D3E 71%, #020B1A 100%)',
    pageHeaderHeight: '56px',
    pageHeaderRadius: '10px',
    danger: '#d32f2f',
    tabInactiveBg: 'linear-gradient(180deg, #DADADA 13%, #DFDFDF 71%, #BCBCBC 100%)',
    tabInactiveText: '#000000',
    inputActiveBg: '#E8F6FB',
    inputActiveBorder: '#6DCEEA',
  },
  JANDARMA_THEME: {
    primary: 'linear-gradient(139.11deg, #03161A -59.11%, #01415D 29.64%, #43DBFA 83.44%)',
    primaryX: 'linear-gradient(90deg, #02638C 13%, #2BB9D8 71%, #43DBFA 100%)',
    secondary: 'linear-gradient(180deg, #2D97C5 10%, #143C68 100%)',
    tertiary: 'linear-gradient(90deg, #02638C 0%, #2BB9D8 52%, #43DBFA 100%)',
    tertiarySolid: '#2BB9D8',
    activeTab: 'linear-gradient(126.04deg, #2D97C5 9.16%, #6DCEEA 84.02%)',
    sidebarBg: '#02638C',
    sidebarBgHover: '#0285b8',
    sidebarAccent: '#014d6e',
    sidebarArrow: '#02638C',
    submenuBg: '#292f3d',
    navItemHoverBg: '#292f3d',
    tableHeaderBg: '#01415D',
    tableHeaderGradient: 'linear-gradient(180deg, #03161A 0%, #01415D 48%, #004962 100%)',
    tableAccent: '#43DBFA',
    tableRowHover: 'rgba(1, 65, 93, 0.045)',
    pageHeaderBg: 'linear-gradient(180deg, #02638C 13%, #2BB9D8 71%, #43DBFA 100%)',
    pageHeaderCardBg: 'linear-gradient(90deg, #02638C 13%, #2BB9D8 71%, #43DBFA 100%)',
    pageHeaderHeight: '60px',
    pageHeaderRadius: '6px',
    danger: '#9C141D',
    tabInactiveBg: 'linear-gradient(180deg, #DADADA 13%, #DFDFDF 71%, #BCBCBC 100%)',
    tabInactiveText: '#000000',
    inputActiveBg: '#E3F5FA',
    inputActiveBorder: '#43DBFA',
  },
  FRAUD_RULE_SET_HISTORY_OPERATIONS: {
    1: "ruleAdded",
    2: "ruleRemoved",
    3: "ruleSetCreated",
    4: "ruleSetUpdated",
    5: "ruleSetDeleted",
    6: "ruleUpdated"
  }
};

// filter language flags according to the configuration
constant.THEMES = {
  banka: constant.BANKA_THEME,
  jandarma: constant.JANDARMA_THEME,
};

const enabledLanguages = process.env.VUE_APP_ENABLED_LANGUAGES.split(',');
constant.ENABLED_LANGUAGES = constant.FLAGS.filter((t) => {
  return enabledLanguages.includes(t.value);
});

constant.HTTPRESTAUTHTYPEITEMS = [
  { text: localize("httpAuthTypes.noAuth"), value: constant.HTTPRESTAUTHTYPES.noAuth },
  { text: localize("httpAuthTypes.apiKey"), value: constant.HTTPRESTAUTHTYPES.apiKey },
  { text: localize("httpAuthTypes.bearerToken"), value: constant.HTTPRESTAUTHTYPES.bearerToken },
  { text: localize("httpAuthTypes.basicAuth"), value: constant.HTTPRESTAUTHTYPES.basicAuth },
  // TODO ATI: aşağısı henüz desteklenmiyor
  // { text: localize("httpAuthTypes.digestAuth"), value: constant.HTTPRESTAUTHTYPES.digestAuth },
  // { text: localize("httpAuthTypes.oAuth_1_0"), value: constant.HTTPRESTAUTHTYPES.oAuth_1_0 },
  // { text: localize("httpAuthTypes.oAuth_2_0"), value: constant.HTTPRESTAUTHTYPES.oAuth_2_0 }
];
constant.HTTPRESTBODYTYPESITEMS = [
  { text: localize("httpRestBodyTypes.none"), value: constant.HTTPRESTBODYTYPES.none },
  { text: localize("httpRestBodyTypes.formData"), value: constant.HTTPRESTBODYTYPES.formData },
  { text: localize("httpRestBodyTypes.xWwwFormUrlEncoded"), value: constant.HTTPRESTBODYTYPES.xWwwFormUrlEncoded },
  { text: localize("httpRestBodyTypes.rawText"), value: constant.HTTPRESTBODYTYPES.rawText },
  { text: localize("httpRestBodyTypes.rawJson"), value: constant.HTTPRESTBODYTYPES.rawJson },
  { text: localize("httpRestBodyTypes.rawJavaScript"), value: constant.HTTPRESTBODYTYPES.rawJavaScript },
  { text: localize("httpRestBodyTypes.rawHtml"), value: constant.HTTPRESTBODYTYPES.rawHtml },
  { text: localize("httpRestBodyTypes.rawXml"), value: constant.HTTPRESTBODYTYPES.rawXml }
];
constant.ENTITYRESTMAPPINGVALUETYPEITEMS = [
  { text: localize("entityRestMappigTypes.string"), value: constant.ENTITYRESTMAPPINGVALUETYPES.string, isComplex: false },
  { text: localize("entityRestMappigTypes.numeric"), value: constant.ENTITYRESTMAPPINGVALUETYPES.numeric, isComplex: false },
  { text: localize("entityRestMappigTypes.longNumeric"), value: constant.ENTITYRESTMAPPINGVALUETYPES.longNumeric, isComplex: false },
  { text: localize("entityRestMappigTypes.decimal"), value: constant.ENTITYRESTMAPPINGVALUETYPES.decimal, isComplex: false },
  { text: localize("entityRestMappigTypes.date"), value: constant.ENTITYRESTMAPPINGVALUETYPES.date, isComplex: false },
  { text: localize("entityRestMappigTypes.datetime"), value: constant.ENTITYRESTMAPPINGVALUETYPES.datetime, isComplex: false },
  { text: localize("entityRestMappigTypes.listOfString"), value: constant.ENTITYRESTMAPPINGVALUETYPES.listOfString, isComplex: true },
  { text: localize("entityRestMappigTypes.listOfNumeric"), value: constant.ENTITYRESTMAPPINGVALUETYPES.listOfNumeric, isComplex: true },
  { text: localize("entityRestMappigTypes.listOfLongNumeric"), value: constant.ENTITYRESTMAPPINGVALUETYPES.listOfLongNumeric, isComplex: true },
  { text: localize("entityRestMappigTypes.listOfDecimal"), value: constant.ENTITYRESTMAPPINGVALUETYPES.listOfDecimal, isComplex: true },
  { text: localize("entityRestMappigTypes.listOfDate"), value: constant.ENTITYRESTMAPPINGVALUETYPES.listOfDate, isComplex: true },
  { text: localize("entityRestMappigTypes.listOfDatetime"), value: constant.ENTITYRESTMAPPINGVALUETYPES.listOfDatetime, isComplex: true },
  { text: localize("entityRestMappigTypes.listOfObject"), value: constant.ENTITYRESTMAPPINGVALUETYPES.listOfObject, isComplex: true }
];

constant.RESTMAPPINGSYSTEMPARAMETERTYPEITEMS = [
  { text: localize("restMappingSystemParameterTypes.description"), value: constant.RESTMAPPINGSYSTEMPARAMETERTYPES.description },
  { text: localize("restMappingSystemParameterTypes.userName"), value: constant.RESTMAPPINGSYSTEMPARAMETERTYPES.userName },
  { text: localize("restMappingSystemParameterTypes.ruleId"), value: constant.RESTMAPPINGSYSTEMPARAMETERTYPES.ruleId },
  // TODO ATI: aşağıdaki bilgiler şu an için giriş yapan kullanıcıda eklenmemiş, o yüzden comment out edildi.
  // { text: localize("restMappingSystemParameterTypes.userId"), value: constant.RESTMAPPINGSYSTEMPARAMETERTYPES.userId },
  // { text: localize("restMappingSystemParameterTypes.userFullName"), value: constant.RESTMAPPINGSYSTEMPARAMETERTYPES.userFullName },
];
constant.SysIncidentIdAttrName = "SYSINCIDENTID";
constant.APPLICATIONMODE = {
  AML: 1,
  FRAUD: 2,
  MIXED: 0
};

constant.RULESTATES = {
  preparing: 1,
  waitForApproval: 2,
  approved: 3,
  rejected: 4,
  waitForDeleteApproval: 5,
  deleteApproved: 6,
  rollBack: 7
};

constant.RULESTATENAMES = {
  1: "preparing",
  2: "waitForApproval",
  3: "approved",
  4: "rejected",
  5: "waitForDeleteApproval",
  6: "deleteApproved",
  7: "rollBack"
};

constant.FRAUD_CASE_HISTORY_TYPES = {
  1: "created",
  2: "statusUpdated",
  3: "assigneeUpdated",
  4: "metadataUpdated",
  5: "incidentAdded",
  6: "documentAdded",
  7: "documentDeleted"
};
constant.FRAUD_INCIDENT_HISTORY_TYPES = {
  1: "created",
  2: "statusUpdated",
  3: "assigneeUpdated",
  4: "metadataUpdated",
  5: "lastServiceStatusUpdated",
  6: "documentAdded",
  7: "documentDeleted",
  8: "actionExecuted",
  9: "actionExecutedForRule"
};
constant.INCIDENTENTITYNAME = "FRINCIDENT";
constant.INCIDENTTABLEUNIQUEKEY = "ID";
constant.TRANSACTIONENTITYNAME = "SRVTRANSACTION";

constant.ALLINCIDENTSSTATEKEY = "incidents";
constant.MYINCIDENTSSTATEKEY = "myIncidents";

constant.GRAPH_STATUSES = {
  New: 1,
  Active: 2,
  ActiveDeleted: 3,
  Creating: 9,
  Error: 99
}

constant.SCENARIO_WAITING_STATUSES = {
  WaitingForDeletionApprove: 1,
  WaitingForActivationApprove: 2,
  WaitingForInactiveApprove: 3,
  WaitingForUpdateApprove: 4,
  DeactivatedBySystem: 5
}

constant.DATASOURCE_TYPES = {
  Service: 2,
  DataSource: 3
}

constant.SOURCE_DETAIL_TYPE_LIST = [
  {
    name: "Sql",
    value: constant.EXECUTION_TYPES.SQL,
    sourceType: 3,
  },
  {
    name: "Oracle",
    value: constant.EXECUTION_TYPES.Oracle,
    sourceType: 3,
  },
  {
    name: "Postgre",
    value: constant.EXECUTION_TYPES.Postgre,
    sourceType: 3,
  },
  {
    name: "ClickHouse",
    value: constant.EXECUTION_TYPES.ClickHouse,
    sourceType: 3,
  },
  {
    name: "Rest",
    value: constant.EXECUTION_TYPES.RestService,
    sourceType: 2,
  },
  {
    name: "Soap",
    value: constant.EXECUTION_TYPES.SoapService,
    sourceType: 2,
  },
];

constant.INFO_REPRESENTATION_TYPE = {
  Table: 1,
  Card: 2,
  All: 3
};

constant.QUERY_SHOW_ON = {
  InfoCard: 1,
  CompoundQuery: 2,
  DigitalTraces: 3,
  IntegratedQuery: 4,
}
constant.VISUAL_RESULT_TYPE = {
  Image: "Image",
  PDF: "PDF"
};

constant.INTEGRATED_QUERY_ATTR_TYPES = {
  Integrated: "integrated",
  Date: "date",
}

constant.willBeRedirectedPagesAfterNewAnalysis = [
  "ScenarioAlerts",
  "Scenarios",
  "DataBinding",
  "PreparedQueries",
  "ImportData",
  "Management",
  "Authorization",
  "ScenarioHistories",
  "AnalysisList",
  "AutosavedSchemaList"
];

constant.LOG_RECORDS_TABS = {
  Pars: 0,
  WhiteList: 1,
  Obligation: 2,
  Kep: 3,
  Kafes: 4,
  ParsAdmin: 5
};

constant.NOTIFICATION_ALLOWED_TYPES = {
  ALLOWED_IMAGE_TYPES: ["image/jpeg", "image/png", "image/gif", "image/webp"],
  ALLOWED_VIDEO_TYPES: ["video/mp4", "video/webm", "video/quicktime"],
  ALLOWED_DOCUMENT_TYPES: [
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "text/plain",
  ],
};

constant.ERROR_KEYWORDS = {
  "NoFilterForSqlExecution": "NoFilterForSqlExecution"
};

constant.FACE_BELGE_TURU = {
  EHLIYET: "ehliyet",
  PASAPORT: "pasaport",
  KIMLIK: "kimlik",
  SURUCU: "surucu",
  KURUM_ARSIVI: "kurum_arsivi",
  DIGER: "diger"
};

constant.FACE_PROCESSING_MODE = {
  INSTANT: "instant",
  QUEUE: "queue"
};

constant.FACE_JOB_TYPE = {
  MANUAL_UPLOAD_BATCH: "manual_upload_batch",
  SEARCH_BATCH: "search_batch"
};

constant.FACE_JOB_STATUS = {
  PENDING: "pending",
  RUNNING: "running",
  COMPLETED: "completed",
  FAILED: "failed",
  CANCELLED: "cancelled"
};

constant.FACE_BATCH_REJECT_REASON = {
  LOW_QUALITY: "low_quality",
  NO_FACE: "no_face",
  MULTIPLE_FACES: "multiple_faces",
  DECODE_FAILED: "decode_failed"
};

constant.FACE_JOB_POLL_INTERVAL_MS = 3000;

constant.FACE_VIDEO_JOB_STATUS = {
  PENDING: "pending",
  RUNNING: "running",
  COMPLETED: "completed",
  FAILED: "failed",
  CANCELLED: "cancelled"
};

constant.FACE_ALARM_STATUS = {
  NEW: "NEW",
  IN_REVIEW: "IN_REVIEW",
  CONFIRMED: "CONFIRMED",
  DISMISSED: "DISMISSED",
  AUTO_CONFIRMED: "AUTO_CONFIRMED"
};

constant.FACE_ALARM_SEVERITY = {
  LOW: "LOW",
  NORMAL: "NORMAL",
  HIGH: "HIGH",
  CRITICAL: "CRITICAL"
};

constant.FACE_SCENARIO_POLL_INTERVAL_MS = 30000;

constant.FACE_VIDEO_POLL_INTERVAL_MS = 5000;
constant.FACE_VIDEO_MAX_SIZE_MB = 500;
constant.FACE_VIDEO_DEFAULT_SAMPLE_FPS = 1.0;
constant.FACE_VIDEO_SAMPLE_FPS_MIN = 0.25;
constant.FACE_VIDEO_SAMPLE_FPS_MAX = 5.0;
constant.FACE_VIDEO_EXT_ALLOWED = ["mp4", "mov", "m4v", "avi", "mkv", "webm", "mpeg", "mpg"];

constant.SCENARIO_ALERT_RFI_VIEWABLE_EXTENSIONS = ["pdf", "png", "jpg", "jpeg"];

constant.SCENARIO_ALERT_RFI_MIME_TYPE_MAP = {
  pdf: "application/pdf",
  png: "image/png",
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  gif: "image/gif",
  docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  doc: "application/msword",
  xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  xls: "application/vnd.ms-excel",
  txt: "text/plain",
};

export default constant;

